<template>
	<form-select v-model="selectedValue"
                 :label="label"
                 :options="filteredOptions"
                 :track-as-integer="true"
                 :error="error"
                 :disabled="disabled"
                 @change="$emit('change', selectedValue)"
    ></form-select>
</template>

<script>
    import FormSelect from "./Select";

	export default {
	    data() {
	        return {
	            selectedValue: null,
                assignedQuantities: {},

                initialised: false,
            }
        },

        model: {
	        event: 'change',
        },

	    props: {
	        value: {
	            required: true,
            },

            label: {
	            type: String,
            },

            options: {
	            type: Array,
                required: true,
            },

            error: {
	            type: String,
            },

            assignedQuantitiesOnLoad: {
	            type: Object,
                required: true,
            },

            disabled: {
	            type: Boolean,
                default: false
            }
        },

        components: {
            FormSelect
        },

        watch: {
	        selectedValue: function (newValue, oldValue) {
	            if (! this.initialised) return false;

	            if (! _.isNull(oldValue)) {
	                this.assignedQuantities[oldValue] = this.assignedQuantities[oldValue] - 1;
                }

                if (! _.isNull(newValue)) {
                    this.assignedQuantities[newValue] = this.assignedQuantities[newValue] + 1;
                }
            }
        },

        created() {
            this.selectedValue = _.clone(this.value);
            this.assignedQuantities = _.cloneDeep(this.assignedQuantitiesOnLoad);

            setTimeout(() => {
                this.initialised = true;
            }, 100);
        },

        computed: {
	        filteredOptions() {
	            return _.reject(this.options, option => {
                    if (option.id === this.selectedValue || _.isNull(option.id)) {
                        return false;
                    }

                    return option.quantity <= this.assignedQuantities[option.id];
                });
            }
        }
    }
</script>
